import * as React from "react";
import PropTypes from "prop-types";
import Button from "nx-components/Button";
import Dialog from "nx-components/Dialog";
import renderInDestroyableRoot from "nexia_mobile/components/Dialogs/renderInDestroyableRoot";

const AlertDialog = ({
  buttonText,
  message,
  onDismiss,
  open,
  ignoreBackgroundClick,
  ignoreRequestClose,
}) => {
  let onBackgroundHandler;
  if (!ignoreBackgroundClick) {
    onBackgroundHandler = onDismiss;
  }

  let onRequestCloseHandler;
  if (!ignoreRequestClose) {
    onRequestCloseHandler = onDismiss;
  }

  const styles = {
    container: {
      margin: "1em",
      minWidth: "10em",
      maxWidth: "80vw",
      overflow: "hidden",
    },
    buttons: {
      textAlign: "center",
      marginTop: "1em",
      marginLeft: "1em",
      marginRight: "1em",
    },
  };
  return (
    <Dialog
      open={open}
      onTapBackground={onBackgroundHandler}
      onRequestClose={onRequestCloseHandler}
    >
      <div style={styles.container}>
        {message}
        <div style={styles.buttons}>
          <Button onTap={onDismiss}>{buttonText}</Button>
        </div>
      </div>
    </Dialog>
  );
};
AlertDialog.propTypes = {
  buttonText: PropTypes.string,
  message: PropTypes.node.isRequired,
  onDismiss: PropTypes.func,
  open: PropTypes.bool,
  ignoreBackgroundClick: PropTypes.bool,
  ignoreRequestClose: PropTypes.bool,
};
AlertDialog.defaultProps = {
  buttonText: "OK",
};

// This method creates a destroyable <div> to mount the AlertDialog in when
// there's no existing React context, like for a Backbone View.

// Usage:
// showAlertDialog({
//   message: "The operation completed successfully",
//   buttonText: "Hurray!",
//   ignoreBackgroundClick: true, // Background clicks will not close the dialog
//   ignoreRequestClose: true, // Pressing Esc or Back (On Android, Win10) will not close the dialog
// });
export function showAlertDialog(options, key) {
  renderInDestroyableRoot((destroyRoot) => {
    const dialogProps = { ...options };

    dialogProps.onDismiss = () => {
      destroyRoot();
      if (_.isFunction(options.onDismiss)) {
        options.onDismiss();
      }
    };

    return <AlertDialog {...dialogProps} open />;
  }, key);
}

export default AlertDialog;



// WEBPACK FOOTER //
// ./src/components/Dialogs/AlertDialog.jsx